import React, { useEffect, useContext } from 'react';
import {
  extend,
  QueryContext
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { NationalDirectory, MostSearchedStores } from '@thd-olt-component-react/store-directory';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { StoreDirectoryMetadata } from '@thd-olt-component-react/metadata';
import { EmtLinks } from '@thd-olt-component-react/emt-links';
import { useLocation } from '@thd-olt-component-react/router';
import { StoreFinderBreadcrumbs } from '../../shared-components/StoreFinderBreadcrumbs';

export const Directory = () => {
  declareContexts([QueryContext, ExperienceContext], { freeze: true });
  const { path } = useContext(ExperienceContext);
  const { pathname } = useLocation();

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-finder.national-directory-page-load', {});
  }, []);

  return (
    <>
      <ErrorBoundary name="national-directory-content">
        <StoreDirectoryMetadata />
      </ErrorBoundary>

      <div className="sui-max-w-screen-2xl sui-m-auto">
        <div className="sui-flex sui-flex-col sui-px-2 2xl:sui-px-0 sui-pt-4 sui-gap-4">
          <ErrorBoundary name="store-directory-breadcrumbs">
            <StoreFinderBreadcrumbs />
          </ErrorBoundary>
          <ErrorBoundary name="sf-directory-nationalDirectory">
            <NationalDirectory />
          </ErrorBoundary>
          <ErrorBoundary name="sf-directory-mostSearchedStores">
            <MostSearchedStores />

          </ErrorBoundary>
          <ErrorBoundary name="sf-directory-explore-more">
            <EmtLinks path={pathname} />
          </ErrorBoundary>
        </div>
      </div>
    </>
  );
};

Directory.displayName = 'StoreDirectory';
Directory.propTypes = {};

Directory.dataModel = extend({},
  NationalDirectory,
  MostSearchedStores,
  EmtLinks,
  StoreFinderBreadcrumbs
);
